import pt from 'prop-types';
import { Component as ReactComponent } from 'react';
import { WindowSize } from './types';
import { SUBSCRIBE_CHANNEL, WindowSizeContext } from './WindowSizeProvider';

const WIDTH_UNKNOWN = -1;

interface WithWindowWidthProps {
    windowWidth: number;
}

const withWindowWidth = <T extends WithWindowWidthProps>(Component: React.ComponentType<T>) =>
    class extends ReactComponent<T, Pick<WindowSize, 'width'>> {
        declare context: WindowSizeContext;
        static contextTypes = {
            [SUBSCRIBE_CHANNEL]: pt.func.isRequired,
        };

        state = {
            width: WIDTH_UNKNOWN,
        };

        private unsubscribe?: () => void;

        onResize = ({ width }: WindowSize) => {
            if (this.state.width !== width) {
                this.setState({ width });
            }
        };

        UNSAFE_componentWillMount() {
            this.unsubscribe = this.context[SUBSCRIBE_CHANNEL](this.onResize);
        }

        componentWillUnmount() {
            if (this.unsubscribe) {
                this.unsubscribe();
            }
        }

        render() {
            return <Component {...this.props} windowWidth={this.state.width} />;
        }
    };

export default withWindowWidth;
